<section [ngClass]="isBackgroundWhite() ? 'background-white' : 'background-cream'">
  @let isRight = data().imagePosition === "right";
  @let isLeft = data().imagePosition === "left";
  <div [class.left]="isLeft" [class.right]="isRight" class="row middle-lg container">
    <div [class.col-lg-offset-1]="isRight" class="col-lg-6 col-xs-12">
      <app-image [image]="data().image" [size]="{ mh: 367, dw: 588, dh: 660 }" />
    </div>
    <div [class.col-lg-offset-1]="isLeft" class="col-lg-5 col-xs-12 content">
      <div class="row">
        <div class="col-lg-12 col-xs-8">
          @if (subtitle()) {
            <app-title [titles]="[subtitle()]" class="sub-title" />
          }
          @if (title()) {
            <app-title [titles]="[title()]" class="title" />
          }
        </div>
      </div>
      @if (data().text; as text) {
        <p [innerHTML]="text"></p>
      }
      @if (cta()) {
        <app-button
          [icon]="cta().icon ?? undefined"
          [label]="cta().label"
          [size]="cta().size"
          [theme]="cta().theme"
          [url]="cta().url ?? ''"
          class="button" />
      }
    </div>
  </div>
</section>
